interface ErrorDetailsProps {
  error: Error & { digest?: string };
}

export function ErrorDetails(props: ErrorDetailsProps): React.ReactNode {
  const { error } = props;

  return (
    <div className="space-y-3">
      <div className="rounded-md bg-muted p-4">
        <p className="text-sm font-mono text-muted-foreground">
          {error.message}
        </p>
      </div>
      {error.digest && (
        <p className="text-xs text-muted-foreground">Digest: {error.digest}</p>
      )}
      {error.stack && (
        <details className="rounded-md bg-muted p-4">
          <summary className="cursor-pointer text-sm font-medium">
            Stack trace
          </summary>
          <pre className="mt-2 text-xs text-muted-foreground overflow-auto">
            {error.stack}
          </pre>
        </details>
      )}
    </div>
  );
}
